import _defineProperty from "/Users/danknasty/linux/Reactive-Resume/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { createStyles } from '@mantine/styles';
import { sizes as sizes$1 } from '../Input/Input.styles.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var sizes = {
  xs: {
    height: sizes$1.xs,
    padding: "0 14px"
  },
  sm: {
    height: sizes$1.sm,
    padding: "0 18px"
  },
  md: {
    height: sizes$1.md,
    padding: "0 22px"
  },
  lg: {
    height: sizes$1.lg,
    padding: "0 26px"
  },
  xl: {
    height: sizes$1.xl,
    padding: "0 32px"
  },
  "compact-xs": {
    height: 22,
    padding: "0 7px"
  },
  "compact-sm": {
    height: 26,
    padding: "0 8px"
  },
  "compact-md": {
    height: 30,
    padding: "0 10px"
  },
  "compact-lg": {
    height: 34,
    padding: "0 12px"
  },
  "compact-xl": {
    height: 40,
    padding: "0 14px"
  }
};
var heights = Object.keys(sizes).reduce(function (acc, size) {
  acc[size] = sizes[size].height;
  return acc;
}, {});

var getSizeStyles = function getSizeStyles(_ref) {
  var compact = _ref.compact,
      size = _ref.size;

  if (!compact) {
    return sizes[size];
  }

  return sizes["compact-".concat(size)];
};

var getWidthStyles = function getWidthStyles(fullWidth) {
  return {
    display: fullWidth ? "block" : "inline-block",
    width: fullWidth ? "100%" : "auto"
  };
};

function getVariantStyles(_ref2) {
  var variant = _ref2.variant,
      theme = _ref2.theme,
      color = _ref2.color;
  var colors = theme.fn.variant({
    color: color,
    variant: variant
  });
  return __spreadValues({
    border: "1px solid ".concat(colors.border),
    backgroundColor: colors.background,
    backgroundImage: colors.background,
    color: colors.color
  }, theme.fn.hover({
    backgroundColor: colors.hover
  }));
}

var useStyles = createStyles(function (theme, _ref3, getRef) {
  var color = _ref3.color,
      size = _ref3.size,
      radius = _ref3.radius,
      fullWidth = _ref3.fullWidth,
      compact = _ref3.compact,
      gradientFrom = _ref3.gradientFrom,
      gradientTo = _ref3.gradientTo,
      gradientDeg = _ref3.gradientDeg;
  var gradient = theme.fn.variant({
    color: color,
    variant: "gradient",
    gradient: {
      from: gradientFrom,
      to: gradientTo,
      deg: gradientDeg
    }
  });
  return {
    loading: {
      ref: getRef("loading"),
      pointerEvents: "none",
      "&::before": {
        content: '""',
        position: "absolute",
        top: -1,
        left: -1,
        right: -1,
        bottom: -1,
        backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[7], 0.5) : "rgba(255, 255, 255, .5)",
        borderRadius: theme.fn.radius(radius),
        cursor: "not-allowed"
      }
    },
    outline: getVariantStyles({
      variant: "outline",
      theme: theme,
      color: color
    }),
    filled: getVariantStyles({
      variant: "filled",
      theme: theme,
      color: color
    }),
    light: getVariantStyles({
      variant: "light",
      theme: theme,
      color: color
    }),
    default: getVariantStyles({
      variant: "default",
      theme: theme,
      color: color
    }),
    white: getVariantStyles({
      variant: "white",
      theme: theme,
      color: color
    }),
    subtle: getVariantStyles({
      variant: "subtle",
      theme: theme,
      color: color
    }),
    gradient: {
      border: 0,
      backgroundImage: gradient.background,
      color: gradient.color,
      "&:hover": theme.fn.hover({
        backgroundSize: "200%"
      })
    },
    root: __spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, getSizeStyles({
      compact: compact,
      size: size
    })), theme.fn.fontStyles()), theme.fn.focusStyles()), getWidthStyles(fullWidth)), _defineProperty({
      borderRadius: theme.fn.radius(radius),
      fontWeight: 600,
      position: "relative",
      lineHeight: 1,
      fontSize: theme.fn.size({
        size: size,
        sizes: theme.fontSizes
      }),
      WebkitTapHighlightColor: "transparent",
      userSelect: "none",
      boxSizing: "border-box",
      textDecoration: "none",
      cursor: "pointer",
      appearance: "none",
      WebkitAppearance: "none",
      "&:not(:disabled):active": {
        transform: "translateY(1px)"
      }
    }, "&:not(.".concat(getRef("loading"), "):disabled"), {
      borderColor: "transparent",
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2],
      color: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[5],
      cursor: "not-allowed"
    })),
    icon: {
      display: "flex",
      alignItems: "center"
    },
    leftIcon: {
      marginRight: 10
    },
    rightIcon: {
      marginLeft: 10
    },
    inner: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      overflow: "visible"
    },
    label: {
      whiteSpace: "nowrap",
      height: "100%",
      overflow: "hidden",
      display: "flex",
      alignItems: "center"
    }
  };
});
export default useStyles;
export { heights };